"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADDRESS = void 0;
exports.ADDRESS = {
    REMOVE_BILLING_TYPE: "REMOVE_BILLING",
    NEW_BILLING_ADDRESS_KEY: "newBillingAddress",
    REMOVE_ADDRESS_ID_KEY: "removeAddressId",
    REMOVE_PRIMARY_KEY: "removePrimary",
    CARD_IDS_KEY: "cardIds",
    OLD_ADDRESS_ID_KEY: "oldAddressId",
    ADDRESS_ID_KEY: "id",
    ADDRESS_IDS: "addressIds",
    IS_OLD_ADDRESS_PRIMARY_KEY: "isOldAddressPrimary",
    ADD_ADDRESS: "ADD-ADDRESS",
    MAKE_PRIMARY: "MAKE-PRIMARY",
    REMOVE_ADDRESS: "REMOVE-ADDRESS",
    UPDATE_ADDRESS: "UPDATE-ADDRESS",
    FLOW_RETURN_VALUE: {
        ADD_ADDRESS: "addAddress",
        ADD_ADDRESS_PRIMARY: "addAddressPrimary",
        REMOVE_BILLING_ADDRESS_PRIMARY: "removeBillingAddressPrimary",
        REMOVE_BILLING_ADDRESS_PRIMARY_BY_ADD_NEW: "removeBillingAddressPrimaryAddNew",
        REMOVE_BILLING_ADDRESS_NON_PRIMARY: "removeBillingAddress",
        REMOVE_BILLING_ADDRESS_NON_PRIMARY_BY_ADD_NEW: "removeBillingAddressAddNew",
        REMOVE_BILLING_ADDRESS_NON_PRIMARY_BY_ADD_NEW_AS_PRIMARY: "removeBillingAddressAddNewPrimary",
        UPDATE_BILLING_ADDRESS_NON_PRIMARY: "updateBillingAddress",
        UPDATE_BILLING_ADDRESS_PRIMARY: "updateBillingAddressPrimary",
        UPDATE_BILLING_ADDRESS_NON_PRIMARY_AS_PRIMARY: "updateBillingAddressAsPrimary",
    },
};
